export const PRIVACY_URL = "https://login.ikizmet.com/privacy.html";
export const TOS_URL = "https://login.ikizmet.com/tos.html";
export const MARKETING_URL = "https://www.clubready.club/fitness-business-analytics";

export const LOGOUT_PATH = "/logout";
